import * as React from "react";
const AnalyticsContext = React.createContext({});
const AnalyticsProvider = (props) => {
  const { children, ...rest } = props;
  const parentContext = React.useContext(AnalyticsContext);
  const contextValue = React.useMemo(
    () => ({
      ...parentContext,
      ...rest
    }),
    [parentContext, rest]
  );
  return /* @__PURE__ */ React.createElement(AnalyticsContext.Provider, { value: contextValue }, children);
};
const useAnalytics = () => {
  const context = React.useContext(AnalyticsContext);
  return {
    push: (id, elementId, interactionTypeArg, trigger) => {
      var _a, _b, _c, _d, _e, _f;
      if (context.onPush) {
        const event = (_a = trigger == null ? void 0 : trigger.event) != null ? _a : context.event;
        const page = (_b = trigger == null ? void 0 : trigger.page) != null ? _b : context.page;
        const group = (_c = trigger == null ? void 0 : trigger.group) != null ? _c : context.group;
        const elementType = (_d = trigger == null ? void 0 : trigger.elementType) != null ? _d : context.elementType;
        const interactionType = (trigger == null ? void 0 : trigger.interactionType) || context.interactionType || interactionTypeArg;
        const conversion = (_e = trigger == null ? void 0 : trigger.conversion) != null ? _e : context.conversion;
        const conversionType = (_f = trigger == null ? void 0 : trigger.conversionType) != null ? _f : context.conversionType;
        if (event && page && group) {
          context.onPush({
            event,
            page,
            group,
            id,
            elementType,
            elementId,
            interactionType,
            conversion,
            conversionType
          });
        }
      }
    }
  };
};
export {
  AnalyticsContext,
  AnalyticsProvider,
  useAnalytics
};
